import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { withSenderPrefix } from '@/lib/format'
import { cn } from '@/lib/utils'

interface ConfirmSendDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** People who will actually get the text. */
  count: number
  message: string
  urgent?: boolean
  title: string
  onConfirm: () => void
}

// The last stop before a text goes to many phones, which can't be unsent. Shows
// the message exactly as it will arrive, including the sender prefix.
export function ConfirmSendDialog({
  open,
  onOpenChange,
  count,
  message,
  urgent = false,
  title,
  onConfirm,
}: ConfirmSendDialogProps) {
  const people = `${count} ${count === 1 ? 'person' : 'people'}`

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            This goes to {people} straight away and can't be recalled.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="max-h-[220px] overflow-y-auto whitespace-pre-wrap rounded-[10px] border border-border bg-surface-2 p-3 text-[13.5px] leading-[1.5] text-foreground [word-break:break-word]">
          {withSenderPrefix(message, urgent)}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep editing</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={cn(urgent && 'bg-destructive text-white hover:bg-destructive/90')}
          >
            {urgent ? `Send urgent to ${people}` : `Send to ${people}`}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
